import { useCallback, useState } from "react"
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    MenuItem, Select, FormControl, InputLabel, TextField
} from "@mui/material"
import { useMutePlayerTOHMutation } from "../../core/api/toh-clans-api"

const MUTE_DURATIONS = [
    { label: "1 hour", s: 3600 },
    { label: "12 hours", s: 43200 },
    { label: "24 hours", s: 86400 },
    { label: "7 days", s: 604800 },
    { label: "30 days", s: 2592000 },
    { label: "Permanently", s: 2147483647 }
]

const TohMuteDialog = ({ open, playerId, onClose }) => {
    const [duration, setDuration] = useState(MUTE_DURATIONS[2].s)
    const [reason, setReason] = useState("")

    const [mute, { isLoading }] = useMutePlayerTOHMutation()

    const handleConfirm = useCallback(async () => {
        const mutedUntilSeconds = Math.floor(Date.now() / 1000) + duration
        await mute({ userId: playerId, mutedUntilSeconds: mutedUntilSeconds, reason: reason.trim() || undefined })
        onClose()
    }, [playerId, duration, reason, mute, onClose])

    const handleClose = useCallback(() => {
        setDuration(MUTE_DURATIONS[2].s)
        setReason("")
        onClose()
    }, [onClose])

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
            <DialogTitle>Mute player '{playerId}'</DialogTitle>
            <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "16px !important" }}>
                <FormControl fullWidth size="small">
                    <InputLabel>Duration</InputLabel>
                    <Select
                        label="Duration"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                    >
                        {MUTE_DURATIONS.map((d) => (
                            <MenuItem key={d.s} value={d.s}>{d.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    fullWidth
                    size="small"
                    label="Reason (optional)"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    inputProps={{ maxLength: 100 }}
                    helperText={`${reason.length}/100`}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" loading={isLoading} onClick={handleConfirm}>
                    Confirm
                </Button>
                <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default TohMuteDialog
